'use client'

import type { Maybe } from '@/frontend-types'
import { formatDate } from '@/helpers/date'
import type { FC } from 'react'
import { useState } from 'react'
import { FontAwesomeIcon } from '../atoms/FontAwesomeIcon'
import { linkIconVariants } from '../atoms/LinkIcon'

export type NewsDateShareBlockProps = {
	date?: Maybe<string>
	readTime?: Maybe<string>
	share: string
}

export const NewsDateShareBlock: FC<NewsDateShareBlockProps> = ({ date, readTime, share }) => {
	const [copyToClipboard, setCopyToClipboard] = useState<string | null>(null)
	const intent = 'primary'

	const shareOnClick = async () => {
		try {
			await navigator.share({
				title: document.title,
				url: window.location.href,
			})
		} catch (error) {
			if (error instanceof Error && error.name !== 'AbortError') {
				const url = window.location.href
				try {
					await navigator.clipboard.writeText(url)
					setTimeout(() => {
						setCopyToClipboard('Copied to clipboard')
					}, 1250)
				} catch (error) {
					console.error('Error copying to clipboard:', error)
					setTimeout(() => {
						setCopyToClipboard('Error copying to clipboard')
					}, 1250)
				}
			}
		}
	}

	return (
		<div className="flex w-full flex-col gap-x-xl tablet-p:flex-row tablet-p:justify-between">
			<div className="flex flex-row items-center gap-x-lg text-body-sm">
				{date && <span>{formatDate(date)}</span>}
				{readTime && <span className="font-semibold">{readTime}</span>}
			</div>
			<button className={linkIconVariants({ intent })} onClick={shareOnClick}>
				<span>{share}</span>
				<FontAwesomeIcon icon={['fas', 'share']} size="md" />
				{copyToClipboard && (
					<div className="absolute top-0 left-0 text-body-sm">{copyToClipboard}</div>
				)}
			</button>
		</div>
	)
}

export default NewsDateShareBlock
